import styled, { css } from 'styled-components';
import { FlexBetween, FlexColumn } from '../../../../styled/common';
import { Typography } from '../../../ui/Typography';

export const RoomsContainer = styled(FlexColumn)`
  padding-bottom: 30px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding-bottom: 0;
  }
`;

export const FilterTitle = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.primary};
  text-align: left;
  margin-bottom: 10px;
`;

export const OptionsWrapper = styled(FlexBetween)`
  gap: 10px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    gap: 0;
  }
`;

export const chipsStyles = css`
  width: 100%;
  height: 44px;
  justify-content: center;
  padding: 0;
  border-radius: 1000px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    width: 44px;
    height: 44px;
    justify-content: center;
  }
`;
